// Styles
import './styles/index.scss';

import {
  setupDocumentJsState,
  initializeCoreRuntime,
  waitForInitialResources
} from './bootstrap/core-runtime';
import {
  initializeProjectInteractions,
  initializeProjectAnimations
} from './bootstrap/project-runtime';

// FOUC prevention must execute as early as possible.
setupDocumentJsState();

// Initialize after DOM and resources ready
document.addEventListener('DOMContentLoaded', () => {
  initializeCoreRuntime();
  initializeProjectInteractions();

  // Wait for fonts and critical resources before revealing animated elements
  waitForInitialResources().then(() => {
    // Mark as ready - reveals scroll-animated elements
    document.documentElement.classList.add('js-ready');
    
    // Initialize animations
    requestAnimationFrame(() => {
      initializeProjectAnimations();
    });
  });
});
